
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "whats-new-in-apache-atlas-24"
    }}>{`What's new in Apache Atlas 2.4?`}</h1>
    <h2 {...{
      "id": "features"
    }}>{`Features`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Search`}</strong>{`: added support to download the search results of Basic and Advanced search.`}</li>
      <li parentName="ul"><strong parentName="li">{`Hook`}</strong>{`: added CouchBase bridge`}</li>
      <li parentName="ul"><strong parentName="li">{`Audits`}</strong>{`: implemented aging for audits`}</li>
      <li parentName="ul"><strong parentName="li">{`Notification`}</strong>{`: utility to analyze hook notifications`}</li>
      <li parentName="ul"><strong parentName="li">{`Ignore/Prune Pattern`}</strong>{` : support ignore patterns to be generic for all the hooks`}</li>
      <li parentName="ul">{`Provide Liveness and Readyness probes`}</li>
    </ul>
    <h2 {...{
      "id": "enhancements"
    }}>{`Enhancements`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Export/Import`}</strong>{`: fixes and enhancements in this feature`}</li>
      <li parentName="ul"><strong parentName="li">{`Dynamic Index Recovery`}</strong>{`: improvements in handling index recovery dynamically`}</li>
      <li parentName="ul"><strong parentName="li">{`Relationship`}</strong>{`: performance improvements in dealing with large number of relationhips`}</li>
      <li parentName="ul"><strong parentName="li">{`Lineage`}</strong>{`: performance improvements by handling data where there is no scope of lineage.`}</li>
      <li parentName="ul"><strong parentName="li">{`Notification Hook Consumer`}</strong>{`: message processing improvement by skipping to retry for specific cases`}</li>
      <li parentName="ul"><strong parentName="li">{`Hbase Compression Algotithm`}</strong>{`: identified SNAPPY compression performs faster, hence support is added to change compression`}</li>
      <li parentName="ul"><strong parentName="li">{`Search`}</strong>{`: support for Chinese character in Atlas entities is added`}</li>
      <li parentName="ul"><strong parentName="li">{`Dependencies Upgrade`}</strong>{`: JanusGraph, Spring Security, Netty, Tinkerpop, Spring Framework, Hbase, Sqoop, Storm, Jetty, Testng`}</li>
      <li parentName="ul"><strong parentName="li">{`UI Dependencies Upgrade`}</strong>{`: Swagger-UI, DomPurify, send, serve-static, elliptic`}</li>
      <li parentName="ul"><strong parentName="li">{`UI`}</strong>{`: fixes and improvements in multiple areas like Glossary, Entity Detail Page, Property tab, Text Editor, Search`}</li>
      <li parentName="ul"><strong parentName="li">{`Log`}</strong>{`: replace use of log4j with logback`}</li>
      <li parentName="ul"><strong parentName="li">{`Docker image`}</strong>{`: improvements to Docker support`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://issues.apache.org/jira/issues/?jql=project%20%3D%20ATLAS%20AND%20fixVersion%20%3D%202.4.0%20ORDER%20BY%20key%20DESC"
        }}>{`List of JIRAs resolved in Apache Atlas 2.4.0 release`}</a></li>
    </ul>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;